import Axios from "axios";
import { setupCache, buildMemoryStorage } from "axios-cache-interceptor";

export interface Template {
  _id: string;
  name: string;
  template: string;
}

const templatesStorage = buildMemoryStorage();
const axiosCached = setupCache(Axios.create(), {
  ttl: 15 * 60 * 1000,
  storage: templatesStorage,
});

export async function getAllTemplates(signal?: AbortSignal) {
  const response = await axiosCached.get<{ postTemplates: Template[] }>(
    "/post-templates",
    { signal }
  );

  return response.data.postTemplates;
}

export async function findPrefixTemplates(
  prefix?: string,
  signal?: AbortSignal
) {
  const templates = await getAllTemplates(signal);
  if (!prefix) {
    return templates;
  }
  return templates.filter((template: Template) =>
    template.name.toLocaleLowerCase().startsWith(prefix.toLocaleLowerCase())
  );
}

export async function removeTemplate(templateId: string) {
  await axiosCached.delete(`/post-templates/${templateId}`);
  // NOTE: invalidate getAllTemplates cache
  await templatesStorage.clear?.();
}

export async function invalidate(): Promise<void> {
  await templatesStorage.clear?.();
}
